import React, { useEffect, useState } from "react";
import { FormControl, InputGroup } from "react-bootstrap";
import { isBrowser } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import LargeModal from "../../../../components/modals/LargeModal";
import {
  closeAcceptLabOrderModal,
  openPrescriptionModal,
} from "../../../../redux/actions/modals";
import { acceptLabOrder } from "../../../../redux/actions/orders";
import toaster from "../../../../utils/toaster";
import CharsUtil from "./../../../../utils/characters.js";
const AcceptLabOrderComponent = (props) => {
  const dispatch = useDispatch();
  const [prices, setPrices] = useState([]);
  const { accept_lab_order_open, lab_order_accept } = useSelector(
    (state) => state.modals
  );
  const { accept_lab_order_waiting } = useSelector((state) => state.orders);
  useEffect(() => {
    if (lab_order_accept.prescriptions.length > 0) {
      let pricesObject = {};
      lab_order_accept.prescriptions.forEach((prescription) => {
        pricesObject[prescription.order_item_id] = {};
        pricesObject[prescription.order_item_id]["regular_price"] = "";
        pricesObject[prescription.order_item_id]["insurance_price"] = "";
      });
      setPrices(pricesObject);
    }
  }, [lab_order_accept]);
  const acceptOrder = () => {
    let current_prices = prices;
    for (const [key, value] of Object.entries(current_prices)) {
      current_prices[key]["regular_price"] = CharsUtil.replaceAll(
        value["regular_price"],
        ",",
        ""
      );
      current_prices[key]["insurance_price"] = CharsUtil.replaceAll(
        value["insurance_price"],
        ",",
        ""
      );
      if (value["regular_price"] === "") {
        toaster.error("لطفا هزینه آیتم‌های موجود را وارد کنید.");
        return;
      }
      if (
        value["insurance_price"] !== "" &&
        parseInt(value["insurance_price"].trim()) > 0
      ) {
        if (
          parseInt(value["regular_price"].trim()) <
          parseInt(value["insurance_price"].trim())
        ) {
          toaster.error("هزینه بدون بیمه نمی‌تواند کمتر از هزینه با بیمه باشد");
          return;
        }
      }
    }
    let data = {
      id: lab_order_accept.id,
      prices: current_prices,
    };
    dispatch(acceptLabOrder(data));
  };
  const checkInput = (char) => {
    let reg = new RegExp("^[0-9,۰-۹]+$");
    return reg.test(char.trim().replace(",", ""));
  };
  return (
    <LargeModal
      header="تایید و ارسال هزینه"
      show={accept_lab_order_open}
      closeFunction={closeAcceptLabOrderModal}
    >
      <div className={isBrowser ? "" : "accept-order-form-holder-mobile"}>
        <div>
          {lab_order_accept.prescriptions.length === 0 ? (
            <div className="list-is-empty">موردی برای ورود هزینه نیست </div>
          ) : (
            <div>
              {lab_order_accept.prescriptions.map((prescription, index) => {
                return (
                  <div key={prescription.id} className="lab-accept-form-holder">
                    <div className="image-holder">
                      <img
                        src={prescription.url}
                        alt="prescription"
                        width={80}
                        onClick={() => {
                          dispatch(openPrescriptionModal(prescription.url));
                        }}
                      />
                    </div>
                    <div className="form-holder">
                      <InputGroup size="sm" className="mb-3">
                        <InputGroup.Prepend>
                          <InputGroup.Text id="inputGroup-sizing-sm">
                            <span> هزینه بدون بیمه </span>{" "}
                            <span style={{ fontWeight: "900" }}> (تومان) </span>
                          </InputGroup.Text>
                        </InputGroup.Prepend>
                        <FormControl
                          aria-describedby="inputGroup-sizing-sm"
                          value={
                            prices[prescription.order_item_id]
                              ? prices[prescription.order_item_id][
                                  "regular_price"
                                ]
                              : ""
                          }
                          onChange={(e) => {
                            if (
                              checkInput(e.target.value) ||
                              e.target.value.trim() === ""
                            ) {
                              let regular_price = CharsUtil.FaToEn(
                                e.target.value.toString()
                              );
                              regular_price = regular_price
                                .replace(new RegExp(",", "g"), "")
                                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                              setPrices((prevState) => ({
                                ...prevState,
                                [prescription.order_item_id]: {
                                  ...prevState[prescription.order_item_id],
                                  regular_price: regular_price,
                                },
                              }));
                            } else {
                              toaster.warning(
                                "لطفا فقط از اعداد استفاده کنید."
                              );
                            }
                          }}
                        />
                      </InputGroup>
                      <InputGroup size="sm" className="mb-3">
                        <InputGroup.Prepend>
                          <InputGroup.Text id="inputGroup-sizing-sm">
                            <span> هزینه با بیمه </span>{" "}
                            <span style={{ fontWeight: "900" }}> (تومان) </span>
                          </InputGroup.Text>
                        </InputGroup.Prepend>
                        <FormControl
                          aria-label="Small"
                          aria-describedby="inputGroup-sizing-sm"
                          value={
                            prices[prescription.order_item_id]
                              ? prices[prescription.order_item_id][
                                  "insurance_price"
                                ]
                              : ""
                          }
                          onChange={(e) => {
                            if (
                              checkInput(e.target.value) ||
                              e.target.value.trim() === ""
                            ) {
                              let insurance_price = CharsUtil.FaToEn(
                                e.target.value.toString()
                              );
                              insurance_price = insurance_price
                                .replace(new RegExp(",", "g"), "")
                                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                              setPrices((prevState) => ({
                                ...prevState,
                                [prescription.order_item_id]: {
                                  ...prevState[prescription.order_item_id],
                                  insurance_price: insurance_price,
                                },
                              }));
                            } else {
                              toaster.warning(
                                "لطفا فقط از اعداد استفاده کنید."
                              );
                            }
                          }}
                        />
                      </InputGroup>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className="reject-order-action-buttons">
          <CustomButton
            className="btn btn-small btn-success text-white"
            action={acceptOrder}
            loading={accept_lab_order_waiting}
            content={"تایید و ارسال هزینه"}
            type={"success"}
            textWhite={true}
            block={false}
          />
          <button
            className="btn btn-small btn-outline-black"
            onClick={() => {
              dispatch(closeAcceptLabOrderModal());
            }}
          >
            انصراف
          </button>
        </div>
      </div>
    </LargeModal>
  );
};

export default AcceptLabOrderComponent;
